module.exports = __webpack_public_path__ + "img/logo.10e5b342.png";